import { Controller } from '@hotwired/stimulus';
import { showModal } from '../utils/modal';
import logger from '../../../app/javascript/analytics/logger';

export default class extends Controller {
  static targets = [
    'nextButtonWrapper',
    'nextButtonVirtual',
    'nextButtonInPerson',
    'nextButtonSelfPaced',
    'inPersonRadioInput',
    'virtualRadioInput',
    'selfPacedRadioInput',
    'inPersonLabel',
    'virtualLabel',
    'selfPacedLabel'
  ];

  initialize() {
    showModal('class-type-selection', { disableFocus: true });
  }

  connect() {
    // this fixes an issue where when you select 'in person' and then navigate to the in_person_classes_guide_path,
    // then navigate back to change your selection, the 'in person' radio input is "checked" under the hood,
    // but the styling does not reflect that checked state.
    setTimeout(() => {
      this.updateButtonLink();
    }, 10);
  }

  isSelectionChecked() {
    return (
      this.inPersonRadioInputTarget.checked ||
      this.virtualRadioInputTarget.checked ||
      this.selfPacedRadioInputTarget.checked
    );
  }

  updateButtonLink() {
    if (!this.isSelectionChecked()) {
      return;
    }

    if (this.isSelectionChecked()) {
      this.nextButtonWrapperTarget.classList.remove(
        'ClassTypeSelection--disabled'
      );
    }

    if (this.inPersonRadioInputTarget.checked) {
      this.nextButtonInPersonTarget.classList.remove('u-visuallyHidden');
      this.nextButtonVirtualTarget.classList.add('u-visuallyHidden');
      this.nextButtonSelfPacedTarget.classList.add('u-visuallyHidden');

      this.inPersonLabelTarget.classList.add(
        'ClassTypeSelection-label--selected'
      );

      this.virtualLabelTarget.classList.remove(
        'ClassTypeSelection-label--selected'
      );

      this.selfPacedLabelTarget.classList.remove(
        'ClassTypeSelection-label--selected'
      );
    } else if (this.virtualRadioInputTarget.checked) {
      this.nextButtonInPersonTarget.classList.add('u-visuallyHidden');
      this.nextButtonVirtualTarget.classList.remove('u-visuallyHidden');
      this.nextButtonSelfPacedTarget.classList.add('u-visuallyHidden');

      this.inPersonLabelTarget.classList.remove(
        'ClassTypeSelection-label--selected'
      );

      this.selfPacedLabelTarget.classList.remove(
        'ClassTypeSelection-label--selected'
      );

      this.virtualLabelTarget.classList.add(
        'ClassTypeSelection-label--selected'
      );
    } else if (this.selfPacedRadioInputTarget.checked) {
      this.nextButtonInPersonTarget.classList.add('u-visuallyHidden');
      this.nextButtonSelfPacedTarget.classList.remove('u-visuallyHidden');
      this.nextButtonVirtualTarget.classList.add('u-visuallyHidden');

      this.inPersonLabelTarget.classList.remove(
        'ClassTypeSelection-label--selected'
      );

      this.virtualLabelTarget.classList.remove(
        'ClassTypeSelection-label--selected'
      );

      this.selfPacedLabelTarget.classList.add(
        'ClassTypeSelection-label--selected'
      );
    }
  }

  trackSelection() {
    logger.trackElementClicked({
      label: `Class Type Selection [${this.idValue}]`,
      elementId: 'Class Type Select Continue'
    });
  }
}
